export const aiAgentsTranslations = {
  en: {
    hero: {
      badge: 'Standalone Course',
      title: 'AI Agents',
      subtitle: 'Build intelligent automation systems that work for you 24/7',
      note: 'This is a separate course, not included in the Full Program'
    },
    content: {
      badge: '🤖 Intelligent Automation',
      description: 'Learn to create AI agents that automate repetitive tasks, make decisions, and scale your productivity. From simple automations to complex multi-agent systems.'
    },
    features: {
      title: 'What You\'ll Learn',
      items: [
        {
          title: 'AI Agent Fundamentals',
          description: 'Understand how AI agents work, their capabilities and limitations'
        },
        {
          title: 'Workflow Automation',
          description: 'Build automated workflows that save hours of manual work'
        },
        {
          title: 'Multi-Agent Systems',
          description: 'Create teams of AI agents that collaborate on complex tasks'
        },
        {
          title: 'API Integrations',
          description: 'Connect your agents to external services and data sources'
        },
        {
          title: 'Error Handling',
          description: 'Build robust agents that handle edge cases gracefully'
        },
        {
          title: 'Deployment & Scaling',
          description: 'Deploy your agents to production and scale them efficiently'
        }
      ]
    },
    useCases: {
      title: 'Use Cases',
      items: [
        {
          title: 'Customer Support',
          description: 'AI agents that handle inquiries 24/7'
        },
        {
          title: 'Data Processing',
          description: 'Automate data extraction and analysis'
        },
        {
          title: 'Content Creation',
          description: 'Generate and schedule content automatically'
        },
        {
          title: 'Task Management',
          description: 'Agents that organize and prioritize your work'
        }
      ]
    },
    cta: {
      goToDashboard: 'Go to Dashboard',
      backToHome: 'Back to Home',
      startLearning: 'Start Learning',
      viewProjects: 'View Projects'
    }
  },
  uk: {
    hero: {
      badge: 'Окремий курс',
      title: 'AI Агенти',
      subtitle: 'Створюйте інтелектуальні системи автоматизації, що працюють на вас 24/7',
      note: 'Це окремий курс, не входить до Full Program'
    },
    content: {
      badge: '🤖 Інтелектуальна автоматизація',
      description: 'Навчіться створювати AI агентів, що автоматизують повторювані завдання, приймають рішення та масштабують вашу продуктивність. Від простих автоматизацій до складних мультиагентних систем.'
    },
    features: {
      title: 'Що ви вивчите',
      items: [
        {
          title: 'Основи AI агентів',
          description: 'Зрозумійте як працюють AI агенти, їх можливості та обмеження'
        },
        {
          title: 'Автоматизація процесів',
          description: 'Створюйте автоматизовані процеси, що економлять години ручної роботи'
        },
        {
          title: 'Мультиагентні системи',
          description: 'Створюйте команди AI агентів, що співпрацюють над складними завданнями'
        },
        {
          title: 'API інтеграції',
          description: 'Підключайте агентів до зовнішніх сервісів та джерел даних'
        },
        {
          title: 'Обробка помилок',
          description: 'Створюйте надійних агентів, що граціозно обробляють крайні випадки'
        },
        {
          title: 'Деплоймент та масштабування',
          description: 'Розгортайте агентів у продакшн та ефективно масштабуйте'
        }
      ]
    },
    useCases: {
      title: 'Приклади використання',
      items: [
        {
          title: 'Підтримка клієнтів',
          description: 'AI агенти, що обробляють запити 24/7'
        },
        {
          title: 'Обробка даних',
          description: 'Автоматизація вилучення та аналізу даних'
        },
        {
          title: 'Створення контенту',
          description: 'Автоматична генерація та планування контенту'
        },
        {
          title: 'Управління завданнями',
          description: 'Агенти, що організовують та пріоритизують вашу роботу'
        }
      ]
    },
    cta: {
      goToDashboard: 'Перейти до панелі',
      backToHome: 'На головну',
      startLearning: 'Почати навчання',
      viewProjects: 'Переглянути проекти'
    }
  }
};
